import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import {useLazyMeQuery} from "../../services/endpoints/user.api";

function RoleProtectedRoute({ element, requiredRole }) {
    const [loading, setLoading] = useState(true);
    const [authorized, setAuthorized] = useState(false);
    const [me, {  isLoading: isMeLoading, isSuccess }] = useLazyMeQuery();

    useEffect(() => {
        const fetchUserRole = async () => {
            try {
                const userData = await me();
                // console.log(userData)

                if (userData.data.data.roles.includes(requiredRole)) {
                setAuthorized(true);

                }
            } catch (err) {
                console.error("Errore nel recupero dell'utente:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchUserRole();
    }, [requiredRole]);

    if (loading) return <div>Caricamento...</div>;

    return authorized ? element : <Navigate to="/login" />;
}

export default RoleProtectedRoute;
